import React from 'react'
import { Container, VStack, Flex, Text, Center, Spinner, Stack } from '@chakra-ui/react';
import { BtNavigate, NavigateParams } from './BtNavigate';

export interface LoadingParams {
    navigation: NavigateParams
    title: string
}

interface LoadingProps {
    navigation: NavigateParams
    title: string
}

const BtLoading: React.FC<LoadingProps> = ({navigation, title}) => {
    return (
        <Container padding={0} size='xl'>
        <Container padding={0} maxW='container.md'>
        <BtNavigate {...navigation} onClick={ () => {}} />
            <Flex pb={20}>
                <VStack w='full' h='full' p={10} >
                    <Center>
                        <Stack w='full' spacing={8} direction={['column', 'column']} alignItems='center'>
                            <Spinner color='brand.500' size='xl' />
                            <Text>{title}</Text>
                        </Stack>
                    </Center>
                    
                </VStack>
                
            </Flex>
        </Container>
    </Container>
       
    )

}

export default BtLoading;